﻿import { Widget } from "blue-widgets";

class SearchInput extends Widget {
  constructor(el) {
    super(el);
    this.input = this.el.querySelector("input");
    this.clearInput = this.el.querySelector("[data-clear]");
    this.results = this.el.parentElement.querySelector(".search-results");
    this.culture = this.el.getAttribute("data-culture");
    this.pageSize = this.el.getAttribute("data-page-size");
    this.homeId = this.el.getAttribute("data-home-id");
    this.init();
  }

  init() {
    // add event listener to this.input for onchange event
    if (this.input) {
      this.input.addEventListener("input", async () => {
        // Check if the value is longer than 2 characters
          if (this.input.value.length > 2) {
              await fetch("/umbraco/Surface/SearchSurface/Search", {
                  method: "POST",
                  headers: {
                      "Content-Type": "application/json",
                  },
                  body: JSON.stringify({
                      query: this.input.value,
                      page: 1,
                      pageSize: this.pageSize,
                      culture: this.culture,
                      homeId: this.homeId
                  })
              })
                  .then(async (response) => {
                      if (response.ok) {
                          const html = await response.text();
                          this.results.innerHTML = html;
                          this.results.classList.add("isOpen");
                      } else {
                          this.results.innerHTML = "";
                          console.error("Error sending POST request. Status:", response.status);
                      }
                  })
                  .catch((error) => {
                      console.error("Error sending POST request:", error);
                  });
        } else {
          // Remove the class isOpen if the value is not longer than 2 characters
          if (this.results) {
            this.results.classList.remove("isOpen");
          }
        }
      });
    }

    // When the user clicks on this.clearInput, it should clear the value of the input
    if (this.clearInput) {
      this.clearInput.addEventListener("click", () => {
        if (this.input) {
          this.input.value = "";
          // Also, remove the isOpen class from this.results
          if (this.results) {
            this.results.classList.remove("isOpen");
          }
        }
      });
    }
    }

}

export default SearchInput;
